import { Stack } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./console.module.scss";
import { useConsole } from "contexts";
import classnames from "classnames";
import Routes from "data/routes";
import { useParams } from "next/navigation";

import Appbar from "./appbar/Appbar";
import Topbar from "./topbar/Topbar";

const ConsoleLayout = ({ children }) => {
  const { currentPath, screen } = useConsole();
  const params = useParams();

  const isReader = currentPath
    ?.replace(params?.bid, "[bid]")
    ?.includes(Routes.read);

  return (
    <Stack
      className={classnames(styles.root, {
        [styles.reader]: isReader && (screen.isTablet || screen.isLandscape),
      })}
      sx={{ minHeight: "100%" }}
    >
      <Topbar />
      {children}
      <Appbar />
    </Stack>
  );
};

ConsoleLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export { Main } from "./section/Main";
export { Section } from "./section/Section";

export default ConsoleLayout;
